module.exports = __webpack_public_path__ + "static/media/Frigidaire.20c82ac3.svg";